<template>
  <AppShell
    v-model:current-lang="currentLang"
    variante="produto"
    evitar-banner-mobile
    @lang-change="onLangChange"
  >
    <!-- HERO ÚNICO: logo + título + vídeo + todos os atalhos -->
    <PageHero
      :logo-src="logoBranco"
      logo-alt="OligoCheck"
      :badge="t.heroBadge"
      badge-variante="azul"
      :subtitulo="t.heroSubtitulo"
    >
      <template #titulo>
        <span class="titulo-resto">{{ t.heroTituloAntes + ' ' }}</span
        ><span class="ds-texto-gradiente">{{ t.heroTituloDestaque }}</span>
      </template>

      <template #ctas>
        <!-- Vídeo de apresentação -->
        <div class="video-wrapper" aria-label="OligoCheck — apresentação">
          <iframe
            src="https://www.youtube.com/embed/kDNl03gcjHM?si=mVbutTlKRkbp3XGT&controls=1&rel=0"
            title="OligoCheck — apresentação"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </div>

        <!-- Credibilidade logo abaixo do vídeo -->
        <div class="trust-inline">
          <TrustBar
            :items="[
              { texto: t.trust1, icone: 'shield' },
              { texto: t.trust2, icone: 'clock' },
              { texto: t.trust3, icone: 'users' }
            ]"
          />
        </div>

        <!-- Label dos atalhos -->
        <p class="caminhos-pergunta">{{ t.linksPergunta }}</p>

        <!-- Grid de atalhos -->
        <div class="caminhos-grid">
          <!-- COMPRAR O APARELHO (destaque laranja) -->
          <a
            :href="whatsappCompraUrl"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-compra"
          >
            <div class="caminho-icone icone-compra">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.compraLabel }}</span>
              <strong class="caminho-titulo">{{ t.compraTitulo }}</strong>
              <span class="caminho-desc">{{ t.compraDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>

          <!-- SUPORTE PÓS-VENDA (verde) -->
          <a
            :href="whatsappSuporteUrl"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-suporte"
          >
            <div class="caminho-icone icone-suporte">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.suporteLabel }}</span>
              <strong class="caminho-titulo">{{ t.suporteTitulo }}</strong>
              <span class="caminho-desc">{{ t.suporteDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>

          <!-- SITE OFICIAL -->
          <a
            href="https://oligocheck.es/"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-site"
          >
            <div class="caminho-icone icone-site">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.siteLabel }}</span>
              <strong class="caminho-titulo">{{ t.siteTitulo }}</strong>
              <span class="caminho-desc">{{ t.siteDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>

          <!-- MAPA DE CLÍNICAS -->
          <a
            href="https://busque.oligocheck.es"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-mapa"
          >
            <div class="caminho-icone icone-mapa">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.mapaLabel }}</span>
              <strong class="caminho-titulo">{{ t.mapaTitulo }}</strong>
              <span class="caminho-desc">{{ t.mapaDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>

          <!-- CONTEÚDO -->
          <a
            href="/contenido"
            @click.prevent="irPara('/contenido')"
            class="caminho-card caminho-conteudo-card"
          >
            <div class="caminho-icone icone-conteudo">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5 3 19 12 5 21 5 3"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.conteudoLabel }}</span>
              <strong class="caminho-titulo">{{ t.conteudoTitulo }}</strong>
              <span class="caminho-desc">{{ t.conteudoDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>

          <!-- INSTAGRAM -->
          <a
            href="https://www.instagram.com/oligocheck_oficial/"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-instagram"
          >
            <div class="caminho-icone icone-instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.instaLabel }}</span>
              <strong class="caminho-titulo">{{ t.instaTitulo }}</strong>
              <span class="caminho-desc">{{ t.instaDesc }}</span>
            </div>
            <div class="caminho-seta"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></div>
          </a>
        </div>
      </template>
    </PageHero>

    <template #rodape>
      <RodapeSite marca="OligoCheck" />
    </template>
  </AppShell>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import AppShell from '@/components/global/layout/AppShell.vue'
import PageHero from '@/components/global/layout/PageHero.vue'
import RodapeSite from '@/components/global/layout/RodapeSite.vue'
import TrustBar from '@/components/global/ui/TrustBar.vue'
import logoBranco from '@/assets/images/logo-branco.svg'
import { useSeo } from '@/composables/useSeo'

const currentLang = ref('es')
const router = useRouter()

const onLangChange = () => {
  /* AppShell já sinaliza escolha manual internamente. */
}

const irPara = (path) => {
  router.push(path)
}

// WhatsApp de vendas (mesmo usado na landing e na bio atual)
const whatsappCompraFone = '34617488404'
const whatsappCompraUrl = computed(() => {
  const msgs = {
    es: 'Hola! He venido por la BIO DE INSTAGRAM y me gustaría recibir información para adquirir el OligoCheck.',
    pt: 'Olá! Cheguei pela BIO DO INSTAGRAM e gostaria de receber informações para adquirir o OligoCheck.',
    en: 'Hi! I came from the INSTAGRAM BIO and I would like to receive info about getting the OligoCheck.'
  }
  const msg = encodeURIComponent(msgs[currentLang.value])
  return `https://api.whatsapp.com/send/?phone=${whatsappCompraFone}&text=${msg}`
})

// WhatsApp de pós-venda (mesmo atendimento oficial)
const whatsappSuporteFone = '34609644237'
const whatsappSuporteUrl = computed(() => {
  const msgs = {
    es: 'Hola, tengo un equipo OligoCheck y necesito soporte post-venta.',
    pt: 'Olá, tenho um equipamento OligoCheck e preciso de suporte pós-venda.',
    en: 'Hello, I have an OligoCheck device and need post-sale support.'
  }
  const msg = encodeURIComponent(msgs[currentLang.value])
  return `https://api.whatsapp.com/send/?phone=${whatsappSuporteFone}&text=${msg}`
})

const translations = {
  es: {
    heroBadge: 'Link en la bio · OligoCheck oficial',
    heroTituloAntes: 'Bienvenido al universo',
    heroTituloDestaque: 'OligoCheck',
    heroSubtitulo:
      'Conoce la tecnología en el video y elige abajo por dónde seguir.',
    trust1: 'Registrado y homologado',
    trust2: '+10 años en el mercado',
    trust3: '+12.000 profesionales',
    linksPergunta: '¿Qué buscas hoy?',
    compraLabel: 'QUIERO ADQUIRIRLO',
    compraTitulo: 'Hablar con un consultor',
    compraDesc: 'Propuesta personalizada según tu perfil profesional y objetivos.',
    suporteLabel: 'YA TENGO EL EQUIPO',
    suporteTitulo: 'Necesito ayuda',
    suporteDesc: 'Atención directa por WhatsApp para usuarios OligoCheck.',
    siteLabel: 'Sitio oficial',
    siteTitulo: 'Visitar oligocheck.es',
    siteDesc: 'Conoce el equipo, la tecnología y los planes disponibles.',
    mapaLabel: 'Cerca de ti',
    mapaTitulo: 'Mapa de clínicas',
    mapaDesc: 'Localiza profesionales con OligoCheck en tu ciudad.',
    conteudoLabel: 'Exclusivo',
    conteudoTitulo: 'Más contenido en video',
    conteudoDesc: 'Explicaciones técnicas, casos reales y demostraciones.',
    instaLabel: 'Instagram',
    instaTitulo: '@oligocheck_oficial',
    instaDesc: 'Sigue el día a día, novedades y tips de profesionales.'
  },
  pt: {
    heroBadge: 'Link na bio · OligoCheck oficial',
    heroTituloAntes: 'Seja bem-vindo ao universo',
    heroTituloDestaque: 'OligoCheck',
    heroSubtitulo:
      'Conheça a tecnologia no vídeo e escolha abaixo por onde continuar.',
    trust1: 'Registrado e homologado',
    trust2: '+10 anos no mercado',
    trust3: '+12.000 profissionais',
    linksPergunta: 'O que você procura hoje?',
    compraLabel: 'QUERO ADQUIRIR',
    compraTitulo: 'Falar com um consultor',
    compraDesc: 'Proposta personalizada conforme seu perfil profissional e objetivos.',
    suporteLabel: 'JÁ TENHO O EQUIPAMENTO',
    suporteTitulo: 'Preciso de ajuda',
    suporteDesc: 'Atendimento direto pelo WhatsApp para usuários OligoCheck.',
    siteLabel: 'Site oficial',
    siteTitulo: 'Visitar oligocheck.es',
    siteDesc: 'Conheça o aparelho, a tecnologia e os planos disponíveis.',
    mapaLabel: 'Perto de você',
    mapaTitulo: 'Mapa de clínicas',
    mapaDesc: 'Encontre profissionais com OligoCheck na sua cidade.',
    conteudoLabel: 'Exclusivo',
    conteudoTitulo: 'Mais conteúdo em vídeo',
    conteudoDesc: 'Explicações técnicas, casos reais e demonstrações.',
    instaLabel: 'Instagram',
    instaTitulo: '@oligocheck_oficial',
    instaDesc: 'Siga o dia a dia, novidades e dicas de profissionais.'
  },
  en: {
    heroBadge: 'Link in bio · Official OligoCheck',
    heroTituloAntes: 'Welcome to the',
    heroTituloDestaque: 'OligoCheck universe',
    heroSubtitulo:
      'Watch the video to learn about the technology and choose below where to go next.',
    trust1: 'Registered & certified',
    trust2: '+10 years in the market',
    trust3: '+12,000 professionals',
    linksPergunta: 'What are you looking for?',
    compraLabel: 'I WANT TO BUY',
    compraTitulo: 'Talk to a consultant',
    compraDesc: 'Personalized proposal based on your professional profile and goals.',
    suporteLabel: 'I ALREADY OWN THE DEVICE',
    suporteTitulo: 'I need help',
    suporteDesc: 'Direct WhatsApp support for OligoCheck users.',
    siteLabel: 'Official site',
    siteTitulo: 'Visit oligocheck.es',
    siteDesc: 'Learn about the device, the tech and available plans.',
    mapaLabel: 'Near you',
    mapaTitulo: 'Clinic map',
    mapaDesc: 'Find professionals with OligoCheck in your city.',
    conteudoLabel: 'Exclusive',
    conteudoTitulo: 'More video content',
    conteudoDesc: 'Technical explanations, real cases and demos.',
    instaLabel: 'Instagram',
    instaTitulo: '@oligocheck_oficial',
    instaDesc: 'Follow the day-to-day, news and pro tips.'
  }
}

const t = computed(() => translations[currentLang.value])

/* ============================================================
   SEO — metadados dinâmicos por idioma, Open Graph, Twitter Card
   e JSON-LD (Organization, WebSite, WebPage, VideoObject, ItemList,
   BreadcrumbList) para maximizar descoberta orgânica da página-bio.
   ============================================================ */
const SITE_URL = 'https://portal.oligocheck.es'
const PAGE_PATH = '/'
const OG_IMAGE =
  'https://socheck.nyc3.cdn.digitaloceanspaces.com/6dce6cd1afe525bd7b8999-logo%20(1).svg'
const VIDEO_ID = 'kDNl03gcjHM'
const VIDEO_URL = `https://www.youtube.com/watch?v=${VIDEO_ID}`
const VIDEO_EMBED = `https://www.youtube.com/embed/${VIDEO_ID}`
const VIDEO_THUMB = `https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`

const seoContent = {
  es: {
    title:
      'OligoCheck Oficial | Link en la bio — Análisis Mineral Intracelular',
    description:
      'Bienvenido al universo OligoCheck. Habla con un consultor, encuentra una clínica, accede al sitio oficial y descubre por qué más de 12.000 profesionales confían en OligoCheck.',
    keywords: [
      'oligocheck',
      'oligocheck oficial',
      'oligocheck instagram',
      'analisis mineral intracelular',
      'oligoelementos',
      'metales pesados',
      'link en la bio oligocheck',
      'comprar oligocheck',
      'soporte oligocheck',
      'clinica oligocheck',
      'oligocheck profesionales'
    ]
  },
  pt: {
    title:
      'OligoCheck Oficial | Link na bio — Análise Mineral Intracelular',
    description:
      'Seja bem-vindo ao universo OligoCheck. Fale com um consultor, encontre uma clínica, acesse o site oficial e descubra por que mais de 12.000 profissionais confiam no OligoCheck.',
    keywords: [
      'oligocheck',
      'oligocheck oficial',
      'oligocheck instagram',
      'análise mineral intracelular',
      'oligoelementos',
      'metais pesados',
      'link na bio oligocheck',
      'comprar oligocheck',
      'suporte oligocheck',
      'clínica oligocheck',
      'oligocheck profissionais'
    ]
  },
  en: {
    title:
      'Official OligoCheck | Link in bio — Intracellular Mineral Analysis',
    description:
      'Welcome to the OligoCheck universe. Talk to a consultant, find a clinic, visit the official site and discover why over 12,000 professionals trust OligoCheck.',
    keywords: [
      'oligocheck',
      'official oligocheck',
      'oligocheck instagram',
      'intracellular mineral analysis',
      'trace elements',
      'heavy metals',
      'oligocheck link in bio',
      'buy oligocheck',
      'oligocheck support',
      'oligocheck clinic',
      'oligocheck professionals'
    ]
  }
}

const canonicalPorLang = {
  es: `${SITE_URL}${PAGE_PATH}`,
  pt: `${SITE_URL}${PAGE_PATH}?lang=pt`,
  en: `${SITE_URL}${PAGE_PATH}?lang=en`
}

useSeo(() => {
  const lang = currentLang.value
  const seo = seoContent[lang] || seoContent.es
  const translation = translations[lang] || translations.es
  const canonical = canonicalPorLang[lang]

  const linksSchema = [
    { name: translation.compraTitulo,     url: whatsappCompraUrl.value },
    { name: translation.suporteTitulo,    url: whatsappSuporteUrl.value },
    { name: translation.siteTitulo,       url: 'https://oligocheck.es/' },
    { name: translation.mapaTitulo,       url: 'https://busque.oligocheck.es' },
    { name: translation.conteudoTitulo,   url: `${SITE_URL}/contenido` },
    { name: translation.instaTitulo,      url: 'https://www.instagram.com/oligocheck_oficial/' }
  ]

  const structuredData = [
    /* Organização — idêntica à da landing para reforçar entidade única. */
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${SITE_URL}#organization`,
      name: 'OligoCheck',
      url: SITE_URL,
      logo: OG_IMAGE,
      sameAs: [
        'https://www.instagram.com/oligocheck_oficial/',
        'https://oligocheck.es/'
      ]
    },
    /* Site como um todo (útil para sitelinks do Google). */
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${SITE_URL}#website`,
      url: SITE_URL,
      name: 'OligoCheck',
      inLanguage: lang,
      publisher: { '@id': `${SITE_URL}#organization` }
    },
    /* Página atual. */
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${canonical}#webpage`,
      url: canonical,
      name: seo.title,
      description: seo.description,
      inLanguage: lang,
      isPartOf: { '@id': `${SITE_URL}#website` },
      about: { '@id': `${SITE_URL}#organization` },
      primaryImageOfPage: OG_IMAGE
    },
    /* Vídeo embutido na página — sinaliza para Google Video / rich results. */
    {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: `OligoCheck — ${seo.title}`,
      description: seo.description,
      thumbnailUrl: [VIDEO_THUMB],
      uploadDate: '2024-01-01',
      contentUrl: VIDEO_URL,
      embedUrl: VIDEO_EMBED,
      publisher: { '@id': `${SITE_URL}#organization` }
    },
    /* Lista dos atalhos (Google entende como "sitelinks" temáticos). */
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: translation.linksPergunta,
      itemListElement: linksSchema.map((item, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: item.name,
        url: item.url
      }))
    },
    /* Breadcrumb simples (só a home desta SPA). */
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'OligoCheck', item: SITE_URL }
      ]
    }
  ]

  return {
    lang,
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords,
    canonical,
    alternates: {
      'x-default': canonicalPorLang.es,
      es: canonicalPorLang.es,
      pt: canonicalPorLang.pt,
      en: canonicalPorLang.en
    },
    image: OG_IMAGE,
    imageAlt: 'OligoCheck — análise mineral intracelular',
    type: 'website',
    structuredData
  }
})
</script>

<style scoped>
/* ============================================
   TÍTULO — texto após o gradiente
   ============================================ */
.titulo-resto { color: var(--ds-text); }

/* ============================================
   VÍDEO DE APRESENTAÇÃO
   ============================================ */
.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 720px;
  aspect-ratio: 16 / 9;
  margin: 0 auto var(--ds-s-7);
  border-radius: var(--ds-r-xl);
  overflow: hidden;
  background: #000;
  border: 1px solid var(--ds-border);
  box-shadow: 0 30px 80px -20px rgba(0, 0, 0, 0.65),
              0 0 0 1px rgba(20, 203, 240, 0.1);
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* ============================================
   SELOS DE CREDIBILIDADE LOGO ABAIXO DO VÍDEO
   Neutraliza o border-top e o margin-top padrão do TrustBar
   (que foram pensados para uso no fim do hero) e adiciona
   uma divisão sutil abaixo, separando do bloco de atalhos.
   ============================================ */
.trust-inline {
  max-width: 720px;
  margin: 0 auto var(--ds-s-8);
  padding-bottom: var(--ds-s-6);
  border-bottom: 1px solid var(--ds-border-subtle);
}

.trust-inline :deep(.trust-bar) {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
  margin-bottom: 0;
}

/* ============================================
   LABEL ACIMA DO GRID
   ============================================ */
.caminhos-pergunta {
  font-family: var(--ds-font-bold);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--ds-text-dim);
  margin: 0 0 var(--ds-s-5);
  text-align: center;
}

/* ============================================
   GRID DE ATALHOS
   ============================================ */
.caminhos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: var(--ds-s-4);
  max-width: 820px;
  margin: 0 auto;
}

/* ============================================
   CARD (caminho) — base
   ============================================ */
.caminho-card {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  text-align: left;
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-r-lg);
  padding: 22px;
  text-decoration: none;
  color: var(--ds-text);
  transition: all var(--ds-t-smooth);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.caminho-card::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity var(--ds-t-base);
  pointer-events: none;
}

.caminho-card:hover::before { opacity: 1; }

.caminho-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--ds-shadow-lg);
}

/* Glows específicos por variante */
.caminho-compra::before        { background: linear-gradient(135deg, rgba(245, 130, 32, 0.14), transparent 60%); }
.caminho-suporte::before       { background: linear-gradient(135deg, rgba(37, 211, 102, 0.14), transparent 60%); }
.caminho-site::before          { background: linear-gradient(135deg, rgba(20, 203, 240, 0.12), transparent 60%); }
.caminho-mapa::before          { background: linear-gradient(135deg, rgba(26, 175, 149, 0.14), transparent 60%); }
.caminho-conteudo-card::before { background: linear-gradient(135deg, rgba(255, 77, 121, 0.12), transparent 60%); }
.caminho-instagram::before     { background: linear-gradient(135deg, rgba(228, 64, 95, 0.14), transparent 60%); }

.caminho-compra:hover        { border-color: rgba(245, 130, 32, 0.45); }
.caminho-suporte:hover       { border-color: rgba(37, 211, 102, 0.45); }
.caminho-site:hover          { border-color: rgba(20, 203, 240, 0.45); }
.caminho-mapa:hover          { border-color: rgba(26, 175, 149, 0.5); }
.caminho-conteudo-card:hover { border-color: rgba(255, 77, 121, 0.5); }
.caminho-instagram:hover     { border-color: rgba(228, 64, 95, 0.5); }

/* ============================================
   ÍCONE (lado esquerdo)
   ============================================ */
.caminho-icone {
  min-width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  color: #fff;
}

.icone-compra {
  background: var(--ds-gradient-warning);
  box-shadow: var(--ds-shadow-glow-warning);
}

.icone-suporte {
  background: var(--ds-gradient-success);
  box-shadow: var(--ds-shadow-glow-success);
}

.icone-site {
  background: linear-gradient(135deg, #14cbf0, #0fa7c5);
  box-shadow: 0 10px 28px -6px rgba(20, 203, 240, 0.45);
}

.icone-mapa {
  background: linear-gradient(135deg, #1aaf95, #0f8474);
  box-shadow: 0 10px 28px -6px rgba(26, 175, 149, 0.5);
}

.icone-conteudo {
  background: linear-gradient(135deg, #ff4d79, #c41e6b);
  box-shadow: 0 10px 28px -6px rgba(255, 77, 121, 0.5);
}

.icone-instagram {
  background: linear-gradient(135deg, #f58529 0%, #dd2a7b 50%, #8134af 100%);
  box-shadow: 0 10px 28px -6px rgba(221, 42, 123, 0.5);
}

/* ============================================
   CONTEÚDO (centro)
   ============================================ */
.caminho-conteudo {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  position: relative;
  z-index: 1;
  min-width: 0;
}

.caminho-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-bold);
}

.caminho-titulo {
  font-family: var(--ds-font-bold);
  font-size: 17px;
  color: var(--ds-text);
  line-height: 1.25;
}

.caminho-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.45;
  margin-top: 2px;
}

/* ============================================
   SETA (direita)
   ============================================ */
.caminho-seta {
  color: var(--ds-text-faint);
  transition: all var(--ds-t-base);
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-card:hover .caminho-seta {
  color: var(--ds-text);
  transform: translateX(4px);
}

/* ============================================
   RESPONSIVO
   ============================================ */
@media (max-width: 720px) {
  .video-wrapper { border-radius: var(--ds-r-lg); margin-bottom: var(--ds-s-6); }

  .caminhos-grid {
    grid-template-columns: 1fr;
    gap: var(--ds-s-3);
  }

  .caminho-card { padding: 16px; gap: var(--ds-s-3); }
  .caminho-icone { min-width: 48px; height: 48px; }
  .caminho-titulo { font-size: 15px; }
  .caminho-desc { font-size: 12.5px; }
  .caminhos-pergunta { font-size: 12px; letter-spacing: 1.5px; }
}
</style>
